export default {
  "bottom-tab": () => import("/builds/stavax/stavax-frontend/layouts/bottom_tab.vue").then(m => m.default || m),
  dashboard: () => import("/builds/stavax/stavax-frontend/layouts/dashboard.vue").then(m => m.default || m),
  default: () => import("/builds/stavax/stavax-frontend/layouts/default.vue").then(m => m.default || m),
  onboard: () => import("/builds/stavax/stavax-frontend/layouts/onboard.vue").then(m => m.default || m)
}